/**
 * @typedef {{
    metrics: { [key: string]: number };
    attributes?: { [key: string]: string };
    metricsPredicate?: (value) => void;
  }} Message

  @typedef {{
    endPoints: Array<string>; // firebase, sa, prometheus
    type: string;
    url?: string;
    message: Message;
    traceName?: string;
    startTime?: number;
   }} Event
 */

import { FIREBASE_ENDPOINT_NAME, PROMETHEUS_ENDPOINT_NAME } from "./constants";
import { handleEvents as firebaseHandleEvents } from "./endPoints/firebase";
import { handleEvents as promHandleEvents } from "./endPoints/prometheus";
import logger from "./logger";

const SEND_DELAY_MS = 5 * 1000;
const MAX_EVENTS = 50;
const DEFAULT_REMAINING_RETRIES = 5;

let isTransportReady = false;
let remainingTries = DEFAULT_REMAINING_RETRIES;

// 上报数据队列
let queue = [];
let endPointQueue = {};

function processQueue(delay) {
  setTimeout(() => {
    if (remainingTries === 0) {
      return;
    }

    if (!queue.length) {
      return processQueue(SEND_DELAY_MS)
    }

    dispatchQueueEvents();
  }, delay);
}

function dispatchQueueEvents() {
  const staged = queue.slice(0, MAX_EVENTS);
  queue = queue.slice(MAX_EVENTS);
  sendToEndPoints(staged);
}

function addToQueue(data) {
  queue = [...queue, data];
}

export function resetTransport() {
  isTransportReady = false;
  queue = [];
}

export function setUpTransport() {
  if (!isTransportReady) {
    isTransportReady = true;
    processQueue(SEND_DELAY_MS);
  }
}

function sendToEndPoints(staged) {
  const promDatas = staged.filter(data => data.endPoints && data.endPoints.includes(PROMETHEUS_ENDPOINT_NAME));

  if (promDatas.length) {
    // 这里只有单个 endpoint，所以直接在 then, catch 内处理了重试等逻辑
    // 如果是多个，可能需要在每个 handleEvents 内标记数据在某个 endpoint 内成功和失败，进而更新 staged 数据
    // 再放入 queue 中。因此这里处理 staged 的逻辑就会需要加上上一次数据在某个 endpoint 上报结果的处理。
    promHandleEvents(promDatas)
      .then(() => {
        remainingTries = DEFAULT_REMAINING_RETRIES;
        processQueue(SEND_DELAY_MS);
      })
      .catch(() => {
        // 上报失败，将此次数据放入队列，下次继续处理
        remainingTries--;
        logger.info(`上报性能数据剩余重试次数：${remainingTries}`);
        queue = [...staged, ...queue];
        processQueue(SEND_DELAY_MS);
      });
  }
}

/**
 * 
 * @param {Event} event
 */
export function transport(event) {
  // firebase 不延时上报，其 sdk 已实现此功能
  if (event.endPoints.includes(FIREBASE_ENDPOINT_NAME)) {
    firebaseHandleEvents([{ ...event }])
    event.endPoints = event.endPoints.filter(endPoint => endPoint !== FIREBASE_ENDPOINT_NAME);
  }

  addToQueue(event);

  return true;
}
